<template>
  <CockpitDialog
    :title="$t('查看')"
    :top="'200px'"
    :left="'500px'"
    :width="'700px'"
    :height="'500px'"
    @close="close"
  >
    <el-form :model="formData" label-width="150" class="h-120px w-full">
      <el-row>
        <el-col :span="12">
          <el-form-item :label="`${$t('巡检对象名称：')}`">
            <div class="text-hex-fff text-14px truncate leading-40px">{{ formData.name }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="`${$t('巡检点名称：')}`">
            <div class="text-hex-fff text-14px truncate leading-40px">{{ formData.pointName }}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="`${$t('识别类型：')}`">
            <div class="text-hex-fff text-14px truncate leading-40px">{{ formData.type }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="`${$t('识别结果：')}`">
            <div class="text-hex-fff text-14px truncate leading-40px">{{ formData.result }}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="`${$t('采集信息：')}`">
            <div class="text-hex-fff text-14px truncate leading-40px">{{ formData.info }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="`${$t('采集时间：')}`">
            <div class="text-hex-fff text-14px truncate leading-40px">{{ formData.time }}</div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-image class="w-full h-[calc(100%-120px)]" fit="none" :src="url" :preview-src-list="srcList">
    </el-image>
  </CockpitDialog>
</template>

<script>
const CockpitDialog = () => {
  return import('@/components/cockpit/CockpitDialog')
}
export default {
  components: {
    CockpitDialog,
  },
  data() {
    return {
      formData: {
        name: '1123',
        pointName: 'ffff',
        type: '人脸识别',
        result: '通过',
        info: '张三',
        time: '2022-01-01 12:00:00',
      },
      url: require('../../../../assets/images/workAPicture/btn-bg-image1.png'),
      srcList: [require('../../../../assets/images/workAPicture/btn-bg-image1.png')],
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item {
  margin-bottom: 0;
}
</style>
